import { Box, FormControl, InputLabel } from "@mui/material";
import { useState } from "react";
import "./round-textfield.shared.scss";
const RoundedOutlinedContainer = ({ children,title }) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <FormControl
            fullWidth
            variant="outlined"
            className="round-textfield-control"
           
        >
            {/* Floating Label */}
            <InputLabel
                shrink={isFocused}
                className="round-input-label"
            >
                {title}
            </InputLabel>

           {children}
        </FormControl>
    );
};

export default RoundedOutlinedContainer;
